import { ValueOf } from 'utils/utiltyTypes/utilityTypes'
import { EntityAndSchedules } from '@omnea-app/packages/backend/schedulerApiClient/schedulerApiClient'

export const assessmentSchedule = {
  entity: 'assessment',
  actions: {
    submissionReminder: 'submissionReminder',
    startWorkflow: 'startWorkflow',
  },
} as const

export type AssessmentScheduleActions = ValueOf<typeof assessmentSchedule.actions>
export type AssessmentEntityAndSchedule = EntityAndSchedules<typeof assessmentSchedule.entity, AssessmentScheduleActions>
